import axios, { AxiosResponse } from 'axios';
import { createRequestConfig } from './utils';
import DeviceMaint, { DeviceMaintDetail } from '../models/data/DeviceMaint';
import DeviceMaintRequest, {
  DeviceMaintDetailRequest,
} from '../models/requests/GetDeviceMaint';

// 機器点検履歴情報の取得関数
export default function requestDeviceMaintList(
  url: string,
  params?: DeviceMaintRequest,
): Promise<AxiosResponse<DeviceMaint[]>> {
  const config = createRequestConfig({ params });
  return axios.get<DeviceMaint[]>(url, config);
}

// 機器点検履歴情報件数の取得関数
export function requestCountDeviceMaint(
  url: string,
  params?: DeviceMaintRequest,
): Promise<AxiosResponse<number>> {
  const config = createRequestConfig({ params });
  return axios.get<number>(url, config);
}

// 機器点検履歴の詳細情報の取得関数
export function requestDeviceMaintDetail(
  url: string,
  params?: DeviceMaintDetailRequest,
): Promise<AxiosResponse<DeviceMaintDetail>> {
  const config = createRequestConfig({ params });
  return axios.get<DeviceMaintDetail>(url, config);
}
